var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('p',{staticClass:"legend",style:({ backgroundColor: _vm.bgColor, color: _vm.color })},[_c('span',{staticClass:"legend-text"},[_vm._v(_vm._s(_vm.description))])])])}
var staticRenderFns = []

export { render, staticRenderFns }